module.exports = __webpack_public_path__ + "static/img/top_bottom.58210139.png";